module.exports = __webpack_public_path__ + "static/img/sanjiguofanggongye.8b75ade.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/sanjiguofanggongye.jpg
// module id = hcyb
// module chunks = 46